import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "percentage" })
export class PercentagePipe implements PipeTransform {
    transform(value: number, decimals: number): string {
        return (value * 100).toFixed(decimals || 0) + "%";
    }
}
